import EaCalculator from '@propertypal/shared/src/resources/icons/products/ea-calculator-icon.svg';
import BrokerCalcMockup from '@propertypal/shared/src/resources/images/broker-calculator/ea-mortgage-calc-mockup.png';
import ProductsPageHeader from '@propertypal/web-ui/src/headers/products/ProductsPageHeader';
import { Box } from '@propertypal/web-ui/src/layout';
import useMediaQuery from '@propertypal/web-ui/src/media-query/useMediaQuery';
import ProductsContact from '@propertypal/web-ui/src/products/ProductsContact';
import ProductScreenTabs, { ProductScreenTab } from '@propertypal/web-ui/src/products/ProductScreenTabs';
import { Text } from '@propertypal/web-ui/src/typography';
import Head from 'next/head';
import React from 'react';
import generateMetaTags from '../../../components/layout/MetaTags';

const metaData = {
  title: 'Broker Calculator - PropertyPal',
  description: 'Advertise Your Mortgage Broker On Your Property Details Pages For Any Resale Property.',
  url: `/products/estate-agents/broker-calculator`,
};

const tabs: ProductScreenTab[] = [
  {
    title: 'Drive leads to your Mortgage Broker',
    text: `Customise the broker calculator with your Mortgage Broker's logo and colours.`,
    maxW: 320,
  },
];

const breakpoint = 910;

const BrokerCalculator = () => {
  const isMobile = useMediaQuery({ width: breakpoint });
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>

      <ProductsPageHeader
        title="Broker Calculator"
        text="Advertise your Mortgage Broker on your property details pages for any resale property"
        headingProps={{ mb: 10 }}
        subHeadingProps={{ maxWidth: 890, mb: 0 }}
        icon={<EaCalculator />}
      />
      <ProductScreenTabs
        aspectRatio="547 / 456"
        reverse
        negMargin={70}
        mockupWidth={600}
        maxW={1120}
        tabsMt={20}
        breakpoint={1180}
        tabs={tabs}
        button={{
          onClick: () => document.getElementById('contact-us')?.scrollIntoView({ behavior: 'smooth' }),
          text: 'Contact us',
          containerStyle: { maxWidth: '280px' },
        }}
        mockup={{
          src: BrokerCalcMockup.src,
          alt: 'Broker Calculator',
        }}
        content={
          <Box maxWidth={450}>
            <Text mb={20} mt={isMobile ? 0 : 10} lineHeight={25} align="left" data-testid="broker-text">
              Included as part of an Estate Agents advertising activity on PropertyPal, the mortgage broker advert uses
              live rates to provide users with typical mortgage costs.
            </Text>
            <Text mb={20} lineHeight={25} align="left">
              Not only will the advert provide mortgage leads directly to your broker, it will increase brand awareness
              whilst satisfying Mortgage network compliance.
            </Text>
            <Text lineHeight={25} align="left">
              <b>Have your Financial Services partner contact us to find out more.</b>
            </Text>
          </Box>
        }
        staticTabs
      />
      <ProductsContact reason="Broker Calculator" />
    </>
  );
};

export default BrokerCalculator;
